import  { useContext, useState, useEffect, useRef } from "react";
import { BhagavatamCotent, Colour, FontType, UserAudios } from "../global";
import { IonItem, IonToolbar, IonItemDivider, IonLabel, IonSegment, IonSegmentButton, IonPage, IonHeader, IonContent, IonFooter, isPlatform } from "@ionic/react";
import { AnimatePresence, motion } from "framer-motion";

import { QueueMusicSharp, MenuBookSharp, MusicNote } from "@mui/icons-material";

import { Switch, Route, useLocation, useRouteMatch, useHistory } from "react-router-dom";
import SBP from "./sbsong";
import { AutoStoriesSharp, PlayLessonSharp } from "@mui/icons-material";
import SP from "../../sp.svg";

function SB() {
 let { path, url } = useRouteMatch();

 let history = useHistory();
 let location = useLocation();
 const [content2, ] = useContext(BhagavatamCotent)
 const [userAudios, ] = useContext(UserAudios)

const [content, setContent] = useState({chap:[], inside:""});
 const [font, ] = useContext(FontType);

 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";

 const [clr, ] = useContext(Colour);

 let color2, color3, colori, colorh, color4, colorsp;
 if(clr === "1") {
  color2 = "#00CBFE";
  color3 = "white"
  colori = ""
  colorh = "primary"
  colorsp = "#3880ff"
  color4 = "black"
 }
 if(clr === "2") {
  color2 = "#FFE34D";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "black"
 }
 if(clr === "3") {
  color2 = "#FFA500";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
  colorsp = "#FF9933"
  color4 = "black"
 }
 if(clr === "4") {
  color2 = "#87CEEB";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "black"
 }
 if(clr === "5") {
  color2 = "#FFE34D";
  color3 = "black"
  colori = "dark"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "white"
 }
 if(clr === "6") {
  color2 = "#87CEEB";
  color3 = "black"
  colori = "dark"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "white"
 }

 const [spos, setSpos] = useState(0);
 let locy = 0;
 const contentRef = useRef();
 useEffect(() => {
  if (location.pathname === url && contentRef.current) contentRef.current.scrollToPoint(0,spos);
 }, [location, contentRef.current]);

 useEffect(() => {
  let newSongs = {...content};
  newSongs.chap=[];
  for (let i = 0; i < 3; i++) {
    newSongs.chap.push(content2.chap[i]);
  }
  setContent(newSongs);
  setTimeout(function () {
    setContent(content2);
   }, 1);
}, []);

 return (
  <AnimatePresence onExitComplete>
    <>
      <div className="print-hide">
    <IonPage>
      <IonHeader>
     <IonToolbar color={colorh}>
      <IonLabel style={{ marginLeft: "10px", fontFamily: `${fon}` }}> Prayers from Srimad Bhagavatam</IonLabel>
     </IonToolbar>
     </IonHeader>
     <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori}>
         <div style={{ height: "2px" }}></div>
     <motion.div exit={{ opacity: 0 }} animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ type: "linear", duration: 0 }}>
      {content.chap.length !== 0
       ? content.chap.map((part, i1) => {
          return (
           <div key={i1}>
            <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
             <IonLabel style={{ fontFamily: `${fon}` }}>{part.name}</IonLabel>
            </IonItemDivider>

            {content.chap[i1].song.map((td, i2) => {
             return (
              <IonItem key={i2} button={isPlatform('desktop') ? true : false}                color={colori}
              
               onClick={() => {
                
                history.push(`${url}/${i1}_${i2}`);
               }}
              >
               <IonLabel style={{ fontFamily: `${fon}` }}>
                <h2>{td.name.slice(0, td.name.indexOf("(SB"))}</h2>
                <p style={{ fontSize: "11px", color:color4 }}>{td.name.slice(td.name.indexOf("(SB"))}</p>
               </IonLabel>
               {td.link || td.vname || userAudios[td.name.slice(3)] ? <MusicNote style={{ fontSize: "23px" }} />: null}
              </IonItem>
             );
            })}
           </div>
          );
         })
       : null}
     </motion.div>
     </IonContent>
     <IonFooter>
       <IonToolbar mode="md" color={colorh}>
        <IonSegment value="default">
         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/home")}>
          <QueueMusicSharp />
         </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/books")}>
            <MenuBookSharp />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
            <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
           </IonSegmentButton>
           <IonSegmentButton value="default" style={{ minWidth: 0 }} onClick={() => history.push("/sb")}>
            <AutoStoriesSharp />
           </IonSegmentButton>
         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/lists")}>
          <PlayLessonSharp />
         </IonSegmentButton>
        </IonSegment>
       </IonToolbar>
       </IonFooter>
     </IonPage>
     </div>
     <Switch location={location}>
    <Route exact path={path}>
    </Route>
    <Route path={`${path}/:ind`}>
     <SBP SBbook={content2} />
    </Route>
   </Switch>
   </>
  </AnimatePresence>
 );
}

export default SB;
